// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createRegulationInfoRequestToJson, createRegulationInfoResponseFromJson, getRegulationInfoRequestToJson, getRegulationInfoResponseFromJson, getRegulationStatusRequestToJson, getRegulationStatusResponseFromJson, listRegulationInfoRequestToJson, listRegulationInfoResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createRegulationInfo(request) {
    const raw = await fetchRpc('sms.v2.RegulationService/CreateRegulationInfo', createRegulationInfoRequestToJson(request));
    return createRegulationInfoResponseFromJson(raw);
}
export function createRegulationInfo$(request, options) {
    return defer(() => createRegulationInfoWithTransport$(getGlobalTransport(), request, options));
}
export function createRegulationInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.RegulationService/CreateRegulationInfo', createRegulationInfoRequestToJson(request), options)
        .pipe(map(resp => createRegulationInfoResponseFromJson(resp)));
}
export async function getRegulationStatus(request) {
    const raw = await fetchRpc('sms.v2.RegulationService/GetRegulationStatus', getRegulationStatusRequestToJson(request));
    return getRegulationStatusResponseFromJson(raw);
}
export function getRegulationStatus$(request, options) {
    return defer(() => getRegulationStatusWithTransport$(getGlobalTransport(), request, options));
}
export function getRegulationStatusWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.RegulationService/GetRegulationStatus', getRegulationStatusRequestToJson(request), options)
        .pipe(map(resp => getRegulationStatusResponseFromJson(resp)));
}
export async function getRegulationInfo(request) {
    const raw = await fetchRpc('sms.v2.RegulationService/GetRegulationInfo', getRegulationInfoRequestToJson(request));
    return getRegulationInfoResponseFromJson(raw);
}
export function getRegulationInfo$(request, options) {
    return defer(() => getRegulationInfoWithTransport$(getGlobalTransport(), request, options));
}
export function getRegulationInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.RegulationService/GetRegulationInfo', getRegulationInfoRequestToJson(request), options)
        .pipe(map(resp => getRegulationInfoResponseFromJson(resp)));
}
export async function listRegulationInfo(request) {
    const raw = await fetchRpc('sms.v2.RegulationService/ListRegulationInfo', listRegulationInfoRequestToJson(request));
    return listRegulationInfoResponseFromJson(raw);
}
export function listRegulationInfo$(request, options) {
    return defer(() => listRegulationInfoWithTransport$(getGlobalTransport(), request, options));
}
export function listRegulationInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.RegulationService/ListRegulationInfo', listRegulationInfoRequestToJson(request), options)
        .pipe(map(resp => listRegulationInfoResponseFromJson(resp)));
}
